import { GuestActionDto } from "../../../../networking/data/responses/GuestActionDto";
import { GuestActionType } from "../../../../networking/data/responses/GuestActionType";
import { SceneIndex } from "../../../SceneIndex";
import { Action } from "../Action";

export class ScreenAction implements Action {
    public readonly sceneIndex: SceneIndex;

    public constructor(dto: GuestActionDto) {
        if (dto == null) {
            throw new Error("You can't create ScreenAction without providing GuestActionDto.");
        }
        if (dto.type != GuestActionType.SCREEN) {
            throw new Error(`You can't create ScreenAction from GuestActionDto with type equal to ${dto.type}.`);
        }
        if (dto.screenType == undefined || dto.screenType == "") {
            throw new Error(`You can't create ScreenAction from GuestActionDto with screenType equal to ${dto.screenType}.`);
        }
        this.sceneIndex = SceneIndex[dto.screenType as keyof typeof SceneIndex];
        if (this.sceneIndex == undefined) {
            throw new Error(`Failed to convert ${dto.screenType} into SceneIndex value. This popup probably not implemented yet.`);
        }
    }
}